import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TablesComponent} from './tables.component';
import {RouterModule} from '@angular/router';
import {ComponentsModule} from '../../components/components.module';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {SplitButtonModule} from 'primeng/splitbutton';
import {MenuModule} from 'primeng/menu';
import {TableSchemaComponent} from './table-schema/table-schema.component';
import {DividerModule} from 'primeng/divider';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {TableSchemaEditLabelComponent} from './table-schema/table-schema-edit-label/table-schema-edit-label.component';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableDataComponent} from './table-data/table-data.component';
import {PanelModule} from 'primeng/panel';
import {DatePickerModule} from 'primeng/datepicker';
import {MultiSelectModule} from 'primeng/multiselect';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {ConfirmationService} from 'primeng/api';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import { RowEditorComponent } from './table-data/row-editor/row-editor.component';
import {RippleModule} from 'primeng/ripple';
import {ListboxModule} from "primeng/listbox";
import {
    TableSchemaEditLabelInlineComponent
} from "./table-schema/table-schema-edit-label-inline/table-schema-edit-label-inline.component";
import {ToastModule} from "primeng/toast";
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PipesModule } from '../../pipes/pipes.module';


@NgModule({
    declarations: [TablesComponent, TableSchemaComponent, TableSchemaEditLabelComponent, TableDataComponent, RowEditorComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        RouterModule,
        ButtonModule,
        TableModule,
        MenuModule,
        SplitButtonModule,
        DividerModule,
        InputTextModule,
        DynamicDialogModule,
        FormsModule,
        PanelModule,
        DatePickerModule,
        MultiSelectModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        ReactiveFormsModule,
        DropdownModule,
        ConfirmPopupModule,
        RippleModule,
        ListboxModule,
        TableSchemaEditLabelInlineComponent,
        ToastModule,
        TranslateModule,
        RadioButtonModule,
        PipesModule
    ],
    exports: [TablesComponent, TableSchemaComponent, TableDataComponent],
    providers: [
        ConfirmationService
    ]
})
export class TablesModule { }
